export const API_BASE_URL = 'https://tennisnewapp.ru/api';
export const TENNIS_RU_BASE_URL = 'https://prilt.tennis.ru/Tennis_rf/hs/mobileapp';

export const API_ENDPOINTS = {
  login: '/auth/login',
  getArena: (date: string) => `/arena/${date}/new`,
  getRacketTime: (date: string) => `/racket-time/${date}`,
  courts: '/courts',
  // Рассылка SMS/Email уведомлений о статусе кортов (open/close)
  courtStatusNotify: '/court-status/notify',

  // Tennis.ru endpoints
  // Блокировка / разблокировка уличных кортов. Возвращает phones затронутых арендаторов.
  outdoorCourtsBlocking: (isBlock: boolean, startDate?: string, finishDate?: string) => {
    let url = `${TENNIS_RU_BASE_URL}/OutdoorCourtsBlocking/${isBlock}/p`;
    const params: string[] = [];
    if (startDate) params.push(`startDate=${startDate}`);
    if (finishDate) params.push(`finishDate=${finishDate}`);
    if (params.length > 0) url += `?${params.join('&')}`;
    return url;
  },

  // Телефоны контрагентов, арендовавших уличные корты на указанную дату.
  // checkDate в формате YYYY-MM-DDTHH:mm:ss
  phonesOutdoorCourts: (checkDate: string) =>
    `${TENNIS_RU_BASE_URL}/PhonesOutdoorCourts/${checkDate}`,

  // New tennis.ru endpoints
  dailySchedule: (partnerId: string, checkDate: string) =>
    `${TENNIS_RU_BASE_URL}/DailySchedule/${partnerId}/${checkDate}`,

  activeCourts: `${TENNIS_RU_BASE_URL}/ActiveCourts/`
};
